export default "__VITE_ASSET__NjNFCKYV__"